import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

// Injecter le token JWT dans chaque requête
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('monitor_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Rediriger vers /login si 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('monitor_token');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

// ── Auth ──────────────────────────────────────────────────────────────────────
export const login = (email, password) =>
  api.post('/api/auth/login', { email, password });

// ── Services ──────────────────────────────────────────────────────────────────
export const getServices     = ()            => api.get('/api/services');
export const createService   = (data)        => api.post('/api/services', data);
export const updateService   = (id, data)    => api.put(`/api/services/${id}`, data);
export const deleteService   = (id)          => api.delete(`/api/services/${id}`);
export const getIncidents    = (id)          => api.get(`/api/services/${id}/incidents`);
export const getDeletedServices = ()   => api.get('/api/services/deleted');
export const restoreService     = (id) => api.put(`/api/services/${id}/restore`);
export const hardDeleteService  = (id) => api.delete(`/api/services/${id}/permanent`);

// ── Métriques ─────────────────────────────────────────────────────────────────
export const getAvailability  = (name, days = 7) =>
  api.get(`/api/metrics/${encodeURIComponent(name)}/availability?days=${days}`);
export const getResponseTime  = (name, days = 7) =>
  api.get(`/api/metrics/${encodeURIComponent(name)}/response-time?days=${days}`);

// ── Logs ─────────────────────────────────────────────────────────────────────
export const getLogs = (params = {}) =>
  api.get('/api/logs', { params });
export const getMe = () => api.get('/api/auth/me');
// ── SLA ──────────────────────────────────────────────────────────────────────
export const getSlaReport = (month) =>
  api.get('/api/sla/report', { params: { month } });

// ── Maintenances ──────────────────────────────────────────────────────────────
export const getMaintenances   = ()             => api.get('/api/maintenances');
export const createMaintenance = (data)         => api.post('/api/maintenances', data);
export const updateMaintStatus = (id, status)   => api.put(`/api/maintenances/${id}/status`, { status });
export const deleteMaintenance = (id)         => api.delete(`/api/maintenances/${id}`);


// ── USERS ──────────────────────────────────────────────────────────────

export const getUsers   = ()          => api.get('/api/users');
export const createUser = (data)      => api.post('/api/users', data);
export const updateUser = (id, data)  => api.put(`/api/users/${id}`, data);
export const deleteUser = (id)        => api.delete(`/api/users/${id}`);

export default api;
